import React, { Component } from "react";
import { connect } from "react-redux";
import VirtualizedSelect from "react-virtualized-select";
import KpiSummaryLevelOne from "./KpiSummaryLevelOne";
import {
    selectTopology,
    executionMetaData,
} from "./../../../actions/KpiSummaryDashboardEnhanced/SelectTopologyDropDownAction";

class SelectTopologyDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            topologySelected: "",
            viewSummary: false,
        };
    }

    onTopologyChange = (selectVal) => {
        this.setState({
            topologySelected: selectVal,
            viewSummary: false,
        });
    };

    viewSummaryHandler = () => {
        this.setState(() => {
            return {
                viewSummary: true,
            };
        });
        console.log("on submit view", this.state.topologySelected);
        this.props.dispatch(selectTopology(this.state.topologySelected));
        this.props.dispatch(executionMetaData(this.state.topologySelected));
    };

    hideSummaryHandler = () => {
        this.setState(() => {
            return {
                viewSummary: false,
            };
        });
    };

    render() {
        return (
            <div>
                <div
                    className="col-lg-12"
                    style={{ border: "0.2rem solid #757AF7", margin: "1rem 0rem", padding: "1rem" }}
                >
                    <div
                        className="row"
                        style={{ margin: "1% 0%", backgroundColor: "#757AF7", padding: "1%" }}
                    >
                        <div
                            className="col-md-4"
                            style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                color: "#FFFFFF",
                                display: "inline-block",
                            }}
                        >
                            Select Topology Name
                        </div>
                        <div className="col-md-8" style={{ display: "inline-block" }}>
                            <VirtualizedSelect
                                options={this.props.topologyData}
                                onChange={(topologySelect) => this.onTopologyChange(topologySelect)}
                                value={this.state.topologySelected}
                            />
                        </div>
                    </div>
                    {!this.state.viewSummary && (
                        <div className="row" style={{ margin: "1% 0%" }}>
                            <div
                                className="col-md-12"
                                style={{
                                    backgroundColor: "#E2E3FF",
                                    textAlign: "center",
                                    margin: "1% 0%",
                                    padding: "1%",
                                }}
                            >
                                <button
                                    style={{ padding: "0.5%", backgroundColor: "#757AF7" }}
                                    onClick={this.viewSummaryHandler}
                                >
                                    Display summary
                                </button>
                            </div>
                        </div>
                    )}
                    <div>
                        {this.state.viewSummary && (
                            <KpiSummaryLevelOne hideView={this.hideSummaryHandler} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tdata: state.topologyData.topologyData,
});

export default connect(mapStateToProps, undefined)(SelectTopologyDropDown);
